import { jsx as _jsx } from "react/jsx-runtime";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useConfigurationStatus } from "./useConfigurationStatus";
export function ConfigurationStatusButton(props) {
    const { isComplete, statusTextLong, StatusIcon } = useConfigurationStatus(props.cfgObject);
    return (_jsx(Tooltip, { title: statusTextLong, children: _jsx(IconButton, { size: props.size, children: _jsx(StatusIcon, { color: isComplete ? "success" : "warning", fontSize: props.size }) }) }));
}
//# sourceMappingURL=ConfigurationStatusButton.js.map